interface Parameters_<Asset> {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  assetMobile: Asset;
  assetTablet: Asset;
  assetDesktop: Asset;
  assetDefault: Asset;
}

const getDeviceAsset = <Asset>({
  isMobile,
  isTablet,
  isDesktop,
  assetMobile,
  assetTablet,
  assetDesktop,
  assetDefault,
}: Parameters_<Asset>) => {
  if (isMobile) {
    return assetMobile || assetTablet || assetDesktop;
  }

  if (isTablet) {
    return assetTablet || assetDesktop;
  }

  if (isDesktop) {
    return assetDesktop;
  }

  return assetDefault;
};

export default getDeviceAsset;
